module.exports = __webpack_public_path__ + "static/media/bg.ccc03eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/security/3/bg.svg
// module id = 108
// module chunks = 0